/************************************************************
 Local Prescription Task Namespace
 ************************************************************/

window.LocalPrescriptionTaskNS = {
    _action:null,
    _callback:null,
    _row:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        debug.log('LocalPrescriptionTaskNS', action, row, callback);

        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;

        // Cancel Prescription
        if (actionId == 3) {
            LocalPrescriptionTaskNS.openCancelAdministrationWindow();
        }
        // Execute Prescription
        else if (actionId == 19) {
            LocalPrescriptionTaskNS.openAdministrationWindow();
        } else if (actionId == 101) {
            LocalPrescriptionTaskNS.openReason(LocalPrescriptionTaskNS.undoCancel);
        } else if (actionId == 102) {
            LocalPrescriptionTaskNS.openReason(LocalPrescriptionTaskNS.undoExecution);
        }
        // Suspend Prescription -- 13
        // Other actions
        else {
            LocalPrescriptionTaskNS.executeGenericAction();
        }
    },
    // Execute Generic Action
    executeGenericAction:function () {
        workflow.executeAction(LocalPrescriptionTaskNS._action, LocalPrescriptionTaskNS._callback, LocalPrescriptionTaskNS._row);
    },
    openAdministrationWindow: function(){
        Hades.showLoading();
        debug.log("PARAMS - ",LocalPrescriptionTaskNS._action.params);

        var _route_path = '/prescription/administration/administration_detail_modal';

        if (LocalPrescriptionTaskNS._action.params.flg_sos === 't'){
            _route_path = '/prescription/administration/sos_administration_modal';
        }


        $.get(_route_path, LocalPrescriptionTaskNS._action.params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({
                    content: data,
                    autoScale: true,
                    autoDimensions: true,
                    // Give focus to first field
                    afterShow: function(){
                        $('#administration-detail-modal-ct #administration_notes').focus();
                    }
                });

                $('#administration-detail-modal-ct').bind('onClose', LocalPrescriptionTaskNS.onTaskDetailsModalClosed);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                LocalPrescriptionTaskNS._callback(false, LocalPrescriptionTaskNS._action, LocalPrescriptionTaskNS._row);
            });
    },
    openCancelAdministrationWindow: function(){
        Hades.showLoading();

        $.get('/prescription/administration/cancel_administration_modal', LocalPrescriptionTaskNS._action.params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({
                    content: data,
                    autoScale: true,
                    autoDimensions: true,
                    // Give focus to first field
                    afterShow: function(){
                        $('#cancel-administration-modal-ct #administration_cancel_reason').focus();
                    }
                });

                $('#cancel-administration-modal-ct').bind('onClose', LocalPrescriptionTaskNS.onTaskDetailsModalClosed);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                LocalPrescriptionTaskNS._callback(false, LocalPrescriptionTaskNS._action, LocalPrescriptionTaskNS._row);
            });
    },
    onTaskDetailsModalClosed: function(evt, data){
        LocalPrescriptionTaskNS._callback(data.success, LocalPrescriptionTaskNS._action, LocalPrescriptionTaskNS._row);
    },

    openReason:function (callback) {
        var params = {
            task_id:LocalPrescriptionTaskNS._action.task_id,
            wf_id:LocalPrescriptionTaskNS._action.wf_id,
            wf_status_id:LocalPrescriptionTaskNS._action.to_state_id,
            wf_action_id:LocalPrescriptionTaskNS._action.wf_action_id};

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                LocalPrescriptionTaskNS._callback(false, LocalPrescriptionTaskNS._action, LocalPrescriptionTaskNS._row);
            });
    },

    undoCancel: function(event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:LocalPrescriptionTaskNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:LocalPrescriptionTaskNS._row.wf_id,
            wf_status_id:LocalPrescriptionTaskNS._row.wf_status_id,
            wf_action_id:LocalPrescriptionTaskNS._action.wf_action_id};

        $.post('/prescription/administration/undo_cancel', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    LocalPrescriptionTaskNS._callback(false, LocalPrescriptionTaskNS._action, LocalPrescriptionTaskNS._row);
                } else {
                    LocalPrescriptionTaskNS._callback(true, LocalPrescriptionTaskNS._action, LocalPrescriptionTaskNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                LocalPrescriptionTaskNS._callback(false, LocalPrescriptionTaskNS._action, LocalPrescriptionTaskNS._row);
            });
    },

    undoExecution: function(event, data) {
        $.fancybox.close(true);

        var params = {
            task_id:LocalPrescriptionTaskNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:LocalPrescriptionTaskNS._row.wf_id,
            wf_status_id:LocalPrescriptionTaskNS._row.wf_status_id,
            wf_action_id:LocalPrescriptionTaskNS._action.wf_action_id,

            patient_id: LocalPrescriptionTaskNS._action.params.patient_id
        };

        Hades.showLoading();
        $.post('/prescription/administration/undo_execution', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);
                debug.log("cancelamento prescrição: ", data);
                if (data.success != true) {
                    // Hades.showError(Hades.genericErrorMsg(), data.error);
                    bootbox.alert(data.error);
                    Hades.hideLoading();
                    LocalPrescriptionTaskNS._callback(false, LocalPrescriptionTaskNS._action, LocalPrescriptionTaskNS._row);
                } else {
                    Hades.hideLoading();
                    LocalPrescriptionTaskNS._callback(true, LocalPrescriptionTaskNS._action, LocalPrescriptionTaskNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                LocalPrescriptionTaskNS._callback(false, LocalPrescriptionTaskNS._action, LocalPrescriptionTaskNS._row);
            });
    }
};